import { pushGTMEvent } from 'utils/eventGTM';

interface CardEventProps {
    el: HTMLDivElement;
    props: {
        eventName: string;
        eventDate: string;
    };
}

const CardEvent = ({ el, props }: CardEventProps): (() => void) => {
    const btnTicket = el.querySelector('.card-cta.btn-ticket') as HTMLAnchorElement | null;
    const mainCTA = el.querySelector('.card-cta:not(.btn-ticket)') as HTMLAnchorElement | null;

    // Make the card clickable except when clicking on .btn-ticket
    const handleCardClick = (e: MouseEvent): void => {
        if ((e.target as HTMLElement).closest('.btn-ticket')) {
            return;
        }
        if (mainCTA?.href) {
            window.location.assign(mainCTA.href);
        }
    };

    el.addEventListener('click', handleCardClick);

    // Accessibility: handle Enter/Space on card
    const handleKeyDown = (e: KeyboardEvent): void => {
        const active = document.activeElement as HTMLElement;
        if ((e.key === 'Enter' || e.key === ' ') && !active.classList.contains('btn-ticket')) {
            e.preventDefault();
            if (mainCTA?.href) {
                window.location.assign(mainCTA.href);
            }
        }
    };
    el.addEventListener('keydown', handleKeyDown);

    let ticketClickHandler: ((e: MouseEvent) => void) | null = null;
    if (btnTicket) {
        ticketClickHandler = (e: MouseEvent): void => {
            e.preventDefault();
            const { href } = btnTicket;
            pushGTMEvent({
                actionType: 'buy_tickets',
                ev_date: props.eventDate,
                ev_name: props.eventName,
            });
            setTimeout(() => {
                window.location.assign(href);
            }, 200);
        };
        btnTicket.addEventListener('click', ticketClickHandler);
    }

    const handleMouseOver = (e: MouseEvent): void => {
        if (!mainCTA) {
            return;
        }
        const target = e.target as HTMLElement;
        if (btnTicket && (target === btnTicket || btnTicket.contains(target))) {
            mainCTA.classList.remove('hover');
        } else {
            mainCTA.classList.add('hover');
        }
    };
    const handleMouseOut = (): void => {
        if (!mainCTA) {
            return;
        }
        // Always remove hover on mouseout from card
        mainCTA.classList.remove('hover');
    };
    el.addEventListener('mouseover', handleMouseOver);
    el.addEventListener('mouseout', handleMouseOut);

    // Cleanup listeners for SPA/unmount
    return () => {
        el.removeEventListener('click', handleCardClick);
        el.removeEventListener('keydown', handleKeyDown);
        el.removeEventListener('mouseover', handleMouseOver);
        el.removeEventListener('mouseout', handleMouseOut);
        if (btnTicket && ticketClickHandler) {
            btnTicket.removeEventListener('click', ticketClickHandler);
        }
    };
};

export default CardEvent;
